module.exports = __webpack_public_path__ + "static/img/b1.aa8c2c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b1.jpg
// module id = 246
// module chunks = 0 1 2 3 4 5 6 7 8 9